import { Injectable } from '@angular/core';
import { ReportModel } from '../Models/report-model';
import { ScenarioModel } from '../Models/scenario-model';
import { SuiteModel } from '../Models/suite-model';
import { ReportMock } from '../DataStore/Mock/report-mock';
import { RestService } from './rest.service';
import { WebsocketService } from './websocket.service';
import { Observable } from 'rxjs';
import { ProjectService } from './project.service';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  // projectId: string = localStorage.getItem("project_id");


  constructor(private rest: RestService,
    // private websocketService: WebsocketService
    ) { }

  public findByObjectId(id: string) {
    return ReportMock.findByObjectId(id);

  }
  public getItems(size, page,searchText): Observable<any> {
    let projectId = localStorage.getItem("projectId");
    let data={ project: { _id: projectId }, size: size, page: page, searchString:searchText };
    return this.rest.post('getexecutions', data);
  }
  public getItemsdb2(size, page,searchText): Observable<any> {
    let projectId = localStorage.getItem('projectIdDb2');
    let data={ project: { _id: projectId }, size: size, page: page , searchString:searchText};
    return this.rest.post('getexecutionsdb2', data);
  }

  public getReportBySuiteId(suiteModel: SuiteModel): ReportModel[] {
    let suite = [];
    /*
          let s = this.findByObjectId(featureModel.scenario[i]);
     */
    return suite;
  }

  public restartScan(id): Observable<any> {
    //if rescan is suite
    let data = {
      execution: { _id: id }
    }
    return this.rest.put('executeRerunSuite', data);
  }

  public getVideoContent(hubIp: string, filename: string): Observable<any> {
    return this.rest.get('executedVideo', 'dev', filename);
  }
  
  public getVideoContentByToken(token: string): Observable<any> {
    return this.rest.get('executedVideoByToken', token);
  }

  public getReportByToken(token: string): Observable<any> {
    return this.rest.get('reportByToken', token);
  }

  public getVideoShareUrl(hubIp: string, filename: string): Observable<any> {
    return this.rest.get('executedVideoUrl', hubIp, filename);
  }

  public getPresignedVideoShareUrl(hubIp: string, filename: string): Observable<any> {
    return this.rest.get('executedPresignedVideoUrl', hubIp, filename);
  }

  public getExecutionLog(reportId: string): Observable<any> {
    return this.rest.get('executionLog', reportId);
  }

  public getProjectManagementTypesForUser(){
    return this.rest.get('getProjectManagementTypesForUser' , null);
  }

  public getProjectMappingByProjectId(projectId :string){
    return this.rest.get('getProjectMappingByProjectId' , projectId);
  }
}
